/*
 *
 * Return possible queries to use for achievementType.logic
 *
 * Each query has to use the variable $entityId
 * This variable is added in the BE when we compute achievementTypes, to check if an entity has to unlock an achievement
 * To fill other fields (courseId for example) we can hardcode inside the query directly, by using 'args'
 *
 */

const queriesTemplates = [
	{
		id: "all_courses",
		args: [],
		build: () => {
			return `
query internals($entityId: String) {
  internals(where: {id: $entityId}) {
    list {
      courseProgressions {
        isPassed
        score
        lessonsCompletions {
          isPassed
          score
        }
      }
    }
  }
}
`
		}
	},

	// Courses is an array because of the component CoreSelectCourses that return an array of courses
	{
		id: "one_course",
		args: [
			{ id: "courses", localeKey: "course", component: "core-select-course" }
		],
		build: ({ courses }) => {
			return `
query internals($entityId: String) {
  internals(where: {id: $entityId}) {
    list {
      courseProgressions(where: {courseId: "${courses[0].id}" }) {
        isPassed
        score
        lessonsCompletions {
          isPassed
          score
        }
      }
    }
  }
}
`
		}
	}
]

export default queriesTemplates
